/* eslint-disable react/react-in-jsx-scope */
'use client'


import { Link } from "react-router"
import { useState, useContext } from 'react'
import { useCarts, useCartsDispatch } from '../contexts/CartContext';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { XMarkIcon, ShoppingCartIcon,TrashIcon, PlusCircleIcon , MinusCircleIcon   } from '@heroicons/react/24/outline'
import TotalPrice from '../components/totalPrice'


const products = [
  {
    id: 1,
    name: 'Chocolate-Chiffon',
    href: '#',
    discount: '10',
    price: '$90.00',
    quantity: 1,
    imageSrc: 'https://craftstocrumbs.com/wp-content/uploads/2020/07/Chocolate-Chiffon-CTC-scaled.jpg',
    imageAlt: 'Chocolate-Chiffon',
  },
  {
    id: 2,
    name: 'blueberry-chiffon-cake',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://teakandthyme.com/wp-content/uploads/2024/10/blueberry-chiffon-cake-DSC_2632-1x1-1200.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
  {
    id: 3,
    name: 'Chiffon coconut',
    href: '#',
    discount: '10',
    price: '$90.00',
    quantity: 1,
    imageSrc: 'https://zhangcatherine.com/wp-content/uploads/2022/03/12001200.jpg',
    imageAlt: 'Chocolate-Chiffon',
  },
  {
    id: 4,
    name: 'chiffon-cake',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://cookingwithdog.com/wp-content/uploads/2021/03/chiffon-cake-00-1615696212.9265.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
  {
    id: 5,
    name: 'Citrus-Chiffon',
    href: '#',
    discount: '10',
    price: '$90.00',
    quantity: 1,
    imageSrc: 'https://bakefromscratch.com/wp-content/uploads/2022/05/Citrus-Chiffon-312JBweb.jpg',
    imageAlt: 'Chocolate-Chiffon',
  },
  {
    id: 6,
    name: 'Cake browny',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://www.allrecipes.com/thmb/JaPmyuRaOPDlGkkk0FwLKu2eoSo=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/7892-chiffon-cake-ddmfs-11960-4x3-31cd0f36773640b193318e76a978cc0a.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
  {
    id: 7,
    name: 'Yellow Bowl Chiffon',
    href: '#',
    discount: '10',
    price: '$90.00',
    quantity: 1,
    imageSrc: 'https://assets.epicurious.com/photos/627aaf5f080d9862e3bda7d6/1:1/w_2560%2Cc_limit/PandanChiffon_RECIPE_050522_33403.jpg',
    imageAlt: 'Chocolate-Chiffon',
  },
  {
    id: 8,
    name: 'browny Choce',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://www.tasteofhome.com/wp-content/uploads/2018/01/exps164_MC163887B03_10_24b.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
  {
    id: 9,
    name: 'Cake browny',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://theunlikelybaker.com/wp-content/uploads/2017/10/Chocolate-Chiffon-Cake-Recipe-Feature.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
 // More products...
]

export default function Carts() {
  const [open, setOpen] = useState(true)
  const [totalPrice, SettotalPrice] = useState(0);
  // const cartQty = useContext(CartContext);
  // const cartQty = useCartsQty();
  const cart = useCarts();
  const dispatch = useCartsDispatch();

  const apiurl = `${process.env.REACT_APP_API}/products.php`
  const imgurl = `${process.env.REACT_APP_URL}/image/products`

  if(cart.length===0) localStorage.removeItem("cart");

  // console.log(cart);

  return (
    <div className="flex flex-row sm:flex-col w-full sm:w-[220px] md:w-[250px] xl:w-[300px] h-[calc(100vh-80vh)] sm:h-[calc(100vh-120px)] overflow-y-scroll bg-white shadow-xl">
      <div className="flex-1 overflow-y-auto px-2 py-2 sm:px-2">
        <div className="flex items-start justify-between">
          <div className="flex text-xs sm:text-base font-normal sm:font-medium  text-gray-900">
              <p>Shopping cart</p>
            <a
              // type="button"
              href="/cuscart"
              alt="CustomerCart"
              target="_blank"
              className="relative pl-2 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
            >
              {/* <span className="absolute -inset-1.5" /> */}
              <span className="sr-only">View carts</span>
              <ShoppingCartIcon aria-hidden="true" className="h-4 w-4 sm:h-6 sm:w-6 text-gray-500" />
              <div className="relative">
                <span className="flex absolute rounded-full text-[10px] text-center justify-center items-center -top-5 left-3 sm:-top-7 sm:left-5  bg-emerald-500 text-white h-[12px] w-[12px] sm:h-[18px] sm:w-[18px]"
                >{cart.length}</span>
              </div>
            </a>
          </div>

        </div>

        <div className="mt-2">
          <div className="flow-root">
            <ul  className="-my-2  divide-y divide-gray-200">
              {cart.map((product,item) => (
                <li key={item} className="flex py-1">
                  <div className="size-8 sm:size-14 shrink-0 overflow-hidden rounded-md border border-gray-200">
                    {/* <img alt={product.imageSrc} src={`${imgurl}/${product.imageSrc}`} className="size-full object-cover" /> */}
                    <img alt={product.imageSrc} src={`${product.imageSrc}`} className="size-full object-cover" />
                  </div>

                  <div className="ml-2 flex flex-1 flex-col">
                    <div>
                      <div className="flex justify-between text-xs sm:text-sm font-normal text-gray-900">
                        <h3>
                          <a href={product.href}>{product.name}</a>
                        </h3>
                        <p className="font-medium ml-1">{product.price*product.quantity}฿</p>
                      </div>
                      {/* <p className="mt-1 text-sm text-gray-500">{product.color}</p> */}
                    </div>
                    <div className="flex flex-1 items-end justify-between text-sm">
                    <div className="flex">
                      <PlusCircleIcon  
                          onClick={() => {
                                dispatch({
                                  type: 'plus',
                                  pdid: product.pdid,
                                  price: product.price,
                                  quantity: 1
                                  });
                              }}
                          className="h-5 w-5 text-gray-500 hover:text-green-500 hover:cursor-pointer" 
                        />                                
                      <p className="px-2  text-sm font-medium text-gray-500">{product.quantity}</p>
                      <MinusCircleIcon 
                            onClick={() => {
                                dispatch({
                                  type: 'minus',
                                  pdid: product.pdid,
                                  price: product.price,
                                  quantity: 1
                                  });
                              }}
                            className="h-5 w-5 text-gray-500 hover:text-red-500 hover:cursor-pointer" />
                      </div>
                      <div className="flex">
                        <button type="button" 
                          onClick={() => {
                            dispatch({
                              type: 'deleted',
                              pdid: product.pdid
                              });
                          }}
                            className="text-sm font-normal text-indigo-600 hover:text-indigo-500">
                          <TrashIcon  className="h-5 w-5 text-gray-500 hover:text-red-500" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="flex items-end justify-end sm:justify-center sm:w-full w-1/3">

        <div className="w-full fixed-bottom border-t border-gray-200 px-1 py-1 sm:px-4 sm:py-2">
          <div className="flex justify-between text-sm font-normal sm:text-base sm:font-medium text-gray-900">
            <p>Total</p>
            <TotalPrice />
          </div>
          <p className="mt-0.5 text-xs sm:text-sm text-gray-500">Shipping and taxes calculated at checkout.</p>
          <div className="mt-4 px-4">
            <Link
              to="/pos/checkout"
              className="flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-1 text-xs font-normal sm:px-6 sm:py-2 sm:text-base sm:font-medium text-white shadow-sm hover:bg-indigo-700"
            >
              Checkout
            </Link>
          </div>
        </div>
      </div>

    </div>
  )
}
